<template>
    <div class="upcoming-events-content-buttons">
        <rectangle-button
            @rectangleClick="rectangleClick()"
        />
        <v-divider
            inset
            vertical
        />
        <squares-button
            @squaresClick="squaresClick()"        
        />
    </div>
</template>
<script>
    import RectangleButton from '@/components/contentButtons/RectangleButton.vue'
    import SquaresButton from '@/components/contentButtons/SquaresButton.vue'
    
    export default {
        name: 'UpcomingEventsContentButtons',
        components: {
            RectangleButton,
            SquaresButton
        },
        date(){
            return {
                svgData:{
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    pathArr: [
                        {
                            d: 'M3.25 10.75C2.5625 10.75 1.97396 10.5052 1.48438 10.0156C0.994792 9.52604 0.75 8.9375 0.75 8.25V3.25C0.75 2.5625 0.994792 1.97396 1.48438 1.48438C1.97396 0.994792 2.5625 0.75 3.25 0.75H20.75C21.4375 0.75 22.026 0.994792 22.5156 1.48438C23.0052 1.97396 23.25 2.5625 23.25 3.25V8.25C23.25 8.9375 23.0052 9.52604 22.5156 10.0156C22.026 10.5052 21.4375 10.75 20.75 10.75H3.25ZM3.25 8.25H20.75V3.25H3.25V8.25ZM3.25 23.25C2.5625 23.25 1.97396 23.0052 1.48438 22.5156C0.994792 22.026 0.75 21.4375 0.75 20.75V15.75C0.75 15.0625 0.994792 14.474 1.48438 13.9844C1.97396 13.4948 2.5625 13.25 3.25 13.25H20.75C21.4375 13.25 22.026 13.4948 22.5156 13.9844C23.0052 14.474 23.25 15.0625 23.25 15.75V20.75C23.25 21.4375 23.0052 22.026 22.5156 22.5156C22.026 23.0052 21.4375 23.25 20.75 23.25H3.25ZM3.25 20.75H20.75V15.75H3.25V20.75Z',
                            fill: '#0635AC'
                        }
                    ]
                }
            }
        },
        methods: {
            squaresClick(){
                this.$emit('squaresClick')
            },
            rectangleClick(){
                this.$emit('rectangleClick')
            }
        }
    }
</script>